<script>
import periodList from "../periods/periodList.vue";
import costBreakdownTable from "../cost breakdown/costBreakdownTable.vue";
export default {
  components: { periodList, costBreakdownTable },
  name: "offer-modal",
  data: function() {
    return {
      offer: {
        OfferId: null,
        RequirementId: "",
        VesselId: null,
        Contract: "",
        ContractNotes: "",
        OfferStatus: "PEN",
        Duty: "",
        DutyNotes: "",
        DeliveryDateNote: "",
        DeliveryDateStart: "",
        DeliveryDateEnd: null,
        DeliveryLocationNote: "",
        DeliveryLocations: [],
        RedeliveryLocations: [],
        RedeliveryLocationNote: "",
        PeriodNotes: "",
        SubjectNotes: "",
        OfferNotes: "",
        AvailabilityNotes: "",
        MobilisationFee: null,
        MobilisationFeeCurrency: "",
        DemobilisationFee: null,
        DemobilisationFeeCurrency: "",
        DemobilisationNote: "",
        MobilisationNote: "",
        IsCrewChangeConfirmed: false,
        VesselSafetyStatistic: "TBA",
        CompanySafetyStatistic: "TBA",
        CrewChangeFlexibility: "",
        OfferValidity: "",
        Victualling: "",
        FuelPrice: 0,
        FuelPriceUnit: "",
        FuelPriceCurrency: "",
        IsFuelCertificate: false,
        IsWaterCertificate: false,
        CrewChange: null,
        CrewChangeNotes: "",
        Ovid: null,
        Cmid: null,
        AnnualDPTrial: null,
        FMEA: null,
        WaterCertificateDate: null,
        FuelCertificateDate: null,
        HasKenterLink: false,
        PilotExemptionCrew1: [],
        PilotExemptionCrew2: [],
        OfferBreakdowns: [],
      },
      allLocations: [],
      allDuties: [],
      allVesselTypes: [],
      allVessels: [],
      allCurrencies: [],
      contractsByCharterer: [],
      allRequirementStatuses: [],
      allOwners: [],
      requiredRule: [(v) => !!v || "Required"],
      requiredRuleArray: [(v) => (!!v && v.length > 0) || "Required"],
      isDeliveryWindow: false,
      deliveryStartMenu: false,
      offerDueDateMenu: false,
      deliveryEndMenu: false,
      fuelMenu: false,
      waterMenu: false,
      fmeaMenu: false,
      dpTrialMenu: false,
      ovidMenu: false,
      crewChangeMenu: false,
      cmidMenu: false,
      showDeliveryNotes: false,
      showRedeliveryNotes: false,
      allowedMinutes: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
      allSafetyStatistics: [
        { Key: "TBA", Value: "To be confirmed" },
        { Key: "RED", Value: "Red" },
        { Key: "AMB", Value: "Amber" },
        { Key: "GRN", Value: "Green" },
      ],
      ownerId: null,
      commercialManagerId: null,
      tab: null,
      generalComplete: false,
      generalIssue: false,
      periodIssue: false,
      vesselIssue: false,
      cargoIssue: false,
      costIssue: false,
      deliveryDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      deliveryDateEndFormatted: "",
      cmidFormatted: "",
      ovidFormatted: "",
      dpTrialFormatted: "",
      fmeaFormatted: "",
      crewChangeFormatted: "",
      waterCertificateFormatted: "",
      fuelCertificateFormatted: "",
      requirementData: null,
      IncludedInCost: "excl. Fuel, Urea and NOX tax/ Incl. Lubes",
      OfferPeriods: [
        {
          PeriodType: "Day By Day",
          PeriodDurationCount: 14,
          PeriodDurationType: "Days",
          SortOrder: 0,
          Quantity: 1,
          Option: 1,
          Note: "",
          LatestRedeliveryDate: "",
          DailyRate: null,
          DailyRateCurrency: "",
          OnHireDate: null,
          OffHireDate: null,
          DateFixed: null,
          IsAlternateOption: false,
        },
      ],
      beforeSaveDialog: false,
      beforeSaveText: "",
      newOfferStatus: "",
      selectedCostBreakdown: null,
    };
  },
  methods: {
    async getOffer() {
      var result = await this.$store.dispatch("getRequest", { controller: "projectsApi", method: `GetOffer`, parameters: { id: this.itemId } });

      this.offer = result;
      if (this.offer.DeliveryDateEnd) {
        this.isDeliveryWindow = true;
      } else {
        this.isDeliveryWindow = false;
      }
      if (this.offer.DeliveryLocationNotes) {
        this.showDeliveryNotes = true;
      }
      if (this.offer.RedeliveryLocationNotes) {
        this.showRedeliveryNotes = true;
      }
      if (this.offer.OfferBreakdowns.length) {
        this.selectedCostBreakdown = this.offer.OfferBreakdowns[this.offer.OfferBreakdowns.length - 1];
      }

      //need to cleanse dateobjects
      if (this.offer.CrewChange) {
        this.offer.CrewChange = this.offer.CrewChange.split("T")[0];
      }
    },
    resetValidation() {
      this.$refs.generalform.resetValidation();
      this.$refs.vesselform.resetValidation();
    },
    closeModal() {
      this.resetValidation();
      this.$store.commit("setActiveOfferModal", { visible: false, id: null });
    },
    async onSaveClick(status) {
      if (status) {
        this.newOfferStatus = status;
        if (status == "PEN" && this.offer.OfferStatus == "APP") {
          this.beforeSaveText = "Are you sure you want to mark this offer as 'Unapproved'? it may have already been viewed by the charterer.";
          this.beforeSaveDialog = true;
        } else {
          this.createOrUpdate();
        }
        this.offer.OfferStatus = status;
      } else {
        this.newOfferStatus = null;
        this.createOrUpdate();
      }
    },
    onCancelBeforeSave() {
      this.beforeSaveDialog = false;
      this.newOfferStatus = null;
    },
    sendToOwnerForApproval() {},
    async createOrUpdate() {
      if (this.isValid()) {
        if (this.newOfferStatus) {
          this.offer.Status = this.newOfferStatus;
        } else if (!this.offer.Status && !this.offer.Id) {
          this.offer.Status = "PEN";
        }

        var offer = this.offer;
        this.$store.commit("setLoadingAnimation", {
          show: true,
        });
        await this.$store.dispatch("postRequest", { controller: "projectsApi", method: `CreateOrUpdateOffer`, parameters: offer });

        this.$store.commit("setMessage", {
          type: "success",
          content: `Offer Successfully ${offer.OfferId ? "Updated" : "Added"}`,
        });
        this.$store.commit("setLoadingAnimation", null);
        this.onCancelBeforeSave();
        this.closeModal();
      }
    },
    isValid() {
      this.generalIssue = !this.$refs.generalform.validate();
      this.periodIssue = !this.$refs.periodform.validate();
      this.vesselIssue = !this.$refs.vesselform.validate();
      this.costIssue = !this.$refs.costform.validate();
      this.cargoIssue = !this.$refs.cargoform.validate();
      if (!this.generalIssue && !this.vesselIssue && !this.periodIssue) {
        return true;
      } else {
        return false;
      }
    },
    onDeleteItem() {
      this.$refs.form.delete();
    },
    async getLocations() {
      this.allLocations = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetAllLocationsDropdown` });
    },
    async getDuties() {
      this.allDuties = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetDutyTypes` });
    },
    async getAllOwners() {
      this.allOwners = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetAllOwnerCompaniesDropdown` });
    },
    async getAllVessels() {
      this.allVessels = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetAllVesselsForDropdown` });
    },
    async getAllCurrencies() {
      this.allCurrencies = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetCurrencyTypesShort` });
    },
    onHideDeliveryNotes() {
      this.showDeliveryNotes = false;
      this.offer.DeliveryLocationNotes = "";
    },
    onHideRedeliveryNotes() {
      this.showRedeliveryNotes = false;
      this.offer.RedeliveryLocationNotes = "";
    },
    hideEndDate() {
      this.isDeliveryWindow = false;
      this.offer.DeliveryDateEnd = null;
    },
    async getRequirementDetails() {
      return await this.$store.dispatch("getRequest", {
        controller: "projectsApi",
        method: `GetRequirement`,
        parameters: { id: this.activeRequirementId },
      });
    },
    async getVesselDetails(forceUpdate) {
      var result = await this.$store.dispatch("getRequest", {
        controller: "projectsApi",
        method: `GetVesselData`,
        parameters: { id: this.offer.VesselId },
      });
      var safetyData = await this.$store.dispatch("getRequest", {
        controller: "SafetyStat",
        method: `GetSafetyStatisticByVesselAndCharter`,
        parameters: { vesselId: this.offer.VesselId, requirementId: this.activeRequirementId },
      });
      if (result) {
        this.commercialManagerId = result.gin_gvi_commercialManagerId;
        this.ownerId = result.gin_gvi_registeredOwnerId;
        if (!this.offer.OfferId && forceUpdate) {
          var o = this.offer;

          o.PilotExemptionCrew1 =
            result.gin_cre_pilotExemptionCrew1 && result.gin_cre_pilotExemptionCrew1 != "null" ? JSON.parse(result.gin_cre_pilotExemptionCrew1) : [];
          o.PilotExemptionCrew2 =
            result.gin_cre_pilotExemptionCrew2 && result.gin_cre_pilotExemptionCrew2 != "null" ? JSON.parse(result.gin_cre_pilotExemptionCrew2) : [];
          o.Cmid = this.formatIsoDate(result.cer_vce_cmid);
          o.Ovid = this.formatIsoDate(result.cer_vce_ovid);
          o.AnnualDPTrial = this.formatIsoDate(result.cer_vce_annualDpTrial);
          o.FMEA = this.formatIsoDate(result.cer_vce_dpFmea);
          o.WaterCertificateDate = this.formatIsoDate(result.cer_vce_waterCerts);
          o.FuelCertificateDate = this.formatIsoDate(result.cer_vce_fuelCerts);
          o.HasKenterLink = result.ain_gin_kenterLink ? true : false;
        }
      }
      if (safetyData) {
        this.offer.VesselSafetyStatistic = safetyData.vessel;
        this.offer.CompanySafetyStatistic = safetyData.company;
      }
    },
    async resetOfferData() {
      this.offer = {
        OfferId: null,
        RequirementId: "",
        VesselId: null,
        Contract: "",
        ContractNotes: "",
        OfferStatus: "PEN",
        Duty: "",
        DutyNotes: "",
        DeliveryDateNote: "",
        DeliveryDateStart: "",
        DeliveryDateEnd: null,
        DeliveryLocationNote: "",
        DeliveryLocations: [],
        RedeliveryLocations: [],
        RedeliveryLocationNote: "",
        PeriodNotes: "",
        SubjectNotes: "",
        OfferNotes: "",
        AvailabilityNotes: "",
        MobilisationFee: null,
        MobilisationFeeCurrency: "",
        DemobilisationFee: null,
        DemobilisationFeeCurrency: "",
        IsCrewChangeConfirmed: false,
        VesselSafetyStatistic: "TBA",
        CompanySafetyStatistic: "TBA",
        FuelPrice: 0,
        FuelPriceUnit: "",
        FuelPriceCurrency: "",
        IsFuelCertificate: false,
        IsWaterCertificate: false,
        CrewChange: null,
        CrewChangeNotes: "",
        CrewChangeFlexibility: "",
        OfferValidity: "",
        Victualling: "",
        Ovid: null,
        Cmid: null,
        AnnualDPTrial: null,
        FMEA: null,
        WaterCertificateDate: null,
        FuelCertificateDate: null,
        HasKenterLink: false,
        PilotExemptionCrew1: [],
        PilotExemptionCrew2: [],
        OfferBreakdowns: [],
        IncludedInCost: "excl. Fuel, Urea and NOX tax/ Incl. Lubes",
        OfferPeriods: [
          {
            PeriodType: "Day By Day",
            PeriodDurationCount: 14,
            PeriodDurationType: "Days",
            SortOrder: 0,
            Quantity: 1,
            Option: 1,
            Note: "",
            LatestRedeliveryDate: "",
            DailyRate: null,
            DailyRateCurrency: "",
            OnHireDate: null,
            OffHireDate: null,
            DateFixed: null,
            IsAlternateOption: false,
          },
        ],
      };
      this.selectedCostBreakdown = null;
      var req = await this.getRequirementDetails();
      if (req) {
        if (req.DeliveryDateEnd) {
          req.DeliveryDateEnd = req.DeliveryDateEnd.split("T")[0];
        }
        req.DeliveryDateStart = req.DeliveryDateStart.split("T")[0];

        this.offer.DeliveryDateStart = req.DeliveryDateStart;
        this.offer.DeliveryDateEnd = req.DeliveryDateEnd;

        this.isDeliveryWindow = this.offer.DeliveryDateEnd ? true : false;
        this.showDeliveryNotes = req.DeliveryLocationNotes ? true : false;
        this.showRedeliveryNotes = req.RedeliveryLocationNotes ? true : false;

        this.offer.DeliveryDateNote = req.CommencementNote;
        this.offer.RequirementId = req.RequirementId;
        this.offer.DeliveryLocations = req.DeliveryLocations;
        this.offer.RedeliveryLocations = req.RedeliveryLocations;
        this.offer.Contract = req.Contract;
        this.offer.ContractNotes = req.ContractNotes;
        this.offer.DeliveryLocationNote = req.DeliveryLocationNotes;
        this.offer.RedeliveryLocationNote = req.RedeliveryLocationNotes;
        this.offer.Duty = req.Duty;
        this.offer.DutyNotes = req.DutyNotes;
        this.offer.OfferPeriods = req.RequirementPeriods;
        this.offer.SupportingDocuments = req.SupportingDocuments;
        if (req.CostBreakdownTemplateItems && req.CostBreakdownTemplateItems.length) {
          var thisCostBreakdown = {
            OfferCostBreakdownId: emptyGuid(),
            OfferId: null,
            Items: req.CostBreakdownTemplateItems,
            Revision: null,
            Created: null,
            Modified: null,
            CreatedBy: "",
            ModifiedBy: "",
          };
          this.offer.OfferBreakdowns.push(thisCostBreakdown);
          this.selectedCostBreakdown = this.offer.OfferBreakdowns[this.offer.OfferBreakdowns.length - 1];
        }
      }
    },
    onCostBreakDownUpdated(val) {
      var toUpdate = this.offer.OfferBreakdowns.filter(function(x) {
        return x.OfferCostBreakdownId == val.OfferCostBreakdownId;
      })[0];
      if (!toUpdate) {
        //make sure offerId is set
        val.OfferId = this.offer.OfferId;
        this.offer.OfferBreakdowns.push(val);
      } else {
        toUpdate = val;
      }
      this.selectedCostBreakdown = this.offer.OfferBreakdowns[this.offer.OfferBreakdowns.length - 1];
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      if (date.indexOf("T") > -1) {
        date = date.split("T")[0];
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatIsoDate(date) {
      if (date && date.indexOf("T") > -1) {
        date = date.split("T")[0];
      }
      return date;
    },
    isWithinPeriod(date, monthCount) {
      var startOfPeriod = new Date();
      date = new Date(date);
      startOfPeriod.setMonth(startOfPeriod.getMonth() - monthCount);
      if (!date || date < startOfPeriod) {
        return false;
      } else {
        return true;
      }
    },
    allowedDeliveryDates(val) {
      var asDate = new Date(val);
      asDate.setHours(0, 0, 0, 0);
      if (this.offer.OfferId) {
        if (this.offer.DeliveryDateEnd) {
          var deliveryEndAsDate = new Date(this.offer.DeliveryDateEnd);
          deliveryEndAsDate.setHours(0, 0, 0, 0);
          return asDate < deliveryEndAsDate;
        } else {
          return true;
        }
      } else {
        var now = new Date();
        now.setHours(0, 0, 0, 0);

        if (this.offer.DeliveryDateEnd) {
          var deliveryEndAsDate = new Date(this.offer.DeliveryDateEnd);
          deliveryEndAsDate.setHours(0, 0, 0, 0);

          return asDate >= now && asDate < deliveryEndAsDate;
        } else {
          return asDate >= now;
        }
      }
    },
    allowedRedeliveryDates(val) {
      var asDate = new Date(val);
      asDate.setHours(0, 0, 0, 0);
      if (this.offer.OfferId) {
        if (this.offer.DeliveryDateStart) {
          var deliveryStartAsDate = new Date(this.offer.DeliveryDateStart);
          deliveryStartAsDate.setHours(0, 0, 0, 0);
          return asDate > deliveryStartAsDate;
        } else {
          return true;
        }
      } else {
        var now = new Date();
        now.setHours(0, 0, 0, 0);

        if (this.offer.DeliveryDateStart) {
          var deliveryStartAsDate = new Date(this.offer.DeliveryDateStart);
          deliveryStartAsDate.setHours(0, 0, 0, 0);

          return asDate >= now && asDate > deliveryStartAsDate;
        } else {
          return asDate >= now;
        }
      }
    },
  },
  computed: {
    itemId() {
      return this.$store.state.offerModal.id;
    },
    isEdit() {
      return this.itemId !== null;
    },
    activeRequirementId: function() {
      return this.$store.state.activeRequirementId;
    },
    visible: function() {
      return this.$store.state.offerModal && this.$store.state.offerModal.visible;
    },
    isCmidValid() {
      return this.isWithinPeriod(this.offer.Cmid, 12);
    },
    isOvidValid() {
      return this.isWithinPeriod(this.offer.Ovid, 12);
    },
    isCrewChangeValid() {
      return this.isWithinPeriod(this.offer.CrewChange, 0);
    },
  },
  watch: {
    async itemId(val) {
      if (val) {
        await this.getOffer();
      }
    },
    async visible(val) {
      if (val && !this.itemId) {
        await this.resetOfferData();
        this.tab = 1;
      }
      this.$refs.content.scrollTop = 0;
    },
    async "offer.VesselId"(val, oldVal) {
      if (val) {
        this.getVesselDetails((val && oldVal) || !oldVal ? true : false);
      }
    },
    "offer.DeliveryDateStart"(val, oldVal) {
      this.deliveryDateFormatted = this.formatDate(this.offer.DeliveryDateStart);
    },
    "offer.DeliveryDateEnd"(val, oldVal) {
      this.deliveryDateEndFormatted = this.formatDate(this.offer.DeliveryDateEnd);
    },
    "offer.Cmid"(val, oldVal) {
      this.cmidFormatted = this.formatDate(this.offer.Cmid);
    },
    "offer.Ovid"(val, oldVal) {
      this.ovidFormatted = this.formatDate(this.offer.Ovid);
    },
    "offer.AnnualDPTrial"(val, oldVal) {
      this.dpTrialFormatted = this.formatDate(this.offer.AnnualDPTrial);
    },
    "offer.FMEA"(val, oldVal) {
      this.fmeaFormatted = this.formatDate(this.offer.FMEA);
    },
    "offer.CrewChange"(val, oldVal) {
      this.crewChangeFormatted = this.formatDate(this.offer.CrewChange);
    },
    "offer.WaterCertificateDate"(val) {
      this.waterCertificateFormatted = this.formatDate(this.offer.WaterCertificateDate);
    },
    "offer.FuelCertificateDate"(val) {
      this.fuelCertificateFormatted = this.formatDate(this.offer.FuelCertificateDate);
    },
  },
  async mounted() {
    await this.getLocations();
    await this.getDuties();
    await this.getAllOwners();
    await this.getAllVessels();
    await this.getAllCurrencies();
  },
};
</script>
<template>
  <div>
    <v-row justify="center">
      <v-dialog :value="visible" max-width="80%" scrollable persistent>
        <v-card>
          <v-card-title>
            <span class="headline primary--text"
              >{{ isEdit ? `Edit Offer` : `Add Offer` }}<i v-if="isEdit" class="fas fa-edit icon-right"></i><i v-else class="fas fa-plus icon-right"></i
            ></span>
            <v-btn icon dark @click="closeModal()" style="position:absolute;right:5px;top:5px;">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text ref="content">
            <v-stepper v-model="tab" alt-labels non-linear style="overflow:visible">
              <v-stepper-header class="sticky">
                <v-stepper-step step="1" @click.native="tab = 1" editable complete edit-icon="mdi-information-variant" :rules="[() => !generalIssue]">
                  General Information</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step step="2" @click.native="tab = 2" editable complete edit-icon="mdi-cash-multiple" :rules="[() => !periodIssue]"
                  >Period & Rates</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step step="3" @click.native="tab = 3" editable complete edit-icon="mdi-sail-boat" :rules="[() => !vesselIssue]">
                  Vessel Details</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step step="4" @click.native="tab = 4" editable complete edit-icon="mdi-cash-multiple" :rules="[() => !costIssue]">
                  Cost Breakdown</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step step="5" @click.native="tab = 5" editable complete edit-icon="mdi-cube-send" :rules="[() => !cargoIssue]"
                  >Cargo Details
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1" class="pt-0">
                  <v-form ref="generalform">
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12" v-if="!isDeliveryWindow">
                            <v-menu
                              v-model="deliveryStartMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  dense
                                  outlined
                                  hide-details
                                  :rules="requiredRule"
                                  v-model="deliveryDateFormatted"
                                  label="Delivery date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  @blur="offer.DeliveryDateStart = parseDate(deliveryDateFormatted)"
                                  ><template slot="append-outer">
                                    <v-icon @click="isDeliveryWindow = !isDeliveryWindow" title="Switch to delivery window"
                                      >mdi-calendar-multiple</v-icon
                                    ></template
                                  ></v-text-field
                                >
                              </template>
                              <v-date-picker
                                v-model="offer.DeliveryDateStart"
                                @input="deliveryStartMenu = false"
                                :allowed-dates="allowedDeliveryDates"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-col v-else cols="6">
                            <v-menu
                              v-model="deliveryStartMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  outlined
                                  hide-details
                                  :rules="requiredRule"
                                  v-model="deliveryDateFormatted"
                                  label="Earliest Delivery"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  @blur="offer.DeliveryDateStart = parseDate(deliveryDateFormatted)"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="offer.DeliveryDateStart"
                                @input="deliveryStartMenu = false"
                                :allowed-dates="allowedDeliveryDates"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6" v-if="isDeliveryWindow">
                            <v-menu
                              v-model="deliveryEndMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  outlined
                                  hide-details
                                  :rules="requiredRule"
                                  v-model="deliveryDateEndFormatted"
                                  label="Latest Delivery"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  @blur="offer.DeliveryDateEnd = parseDate(deliveryDateEndFormatted)"
                                  ><template slot="append-outer">
                                    <v-icon @click="hideEndDate" title="Switch to single delivery date">mdi-calendar-arrow-left</v-icon></template
                                  ></v-text-field
                                >
                              </template>
                              <v-date-picker
                                v-model="offer.DeliveryDateEnd"
                                @input="deliveryEndMenu = false"
                                :allowed-dates="allowedRedeliveryDates"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea rows="3" dense hide-details="auto" v-model="offer.DeliveryDateNote" outlined label="Delivery Date Notes"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              :rules="requiredRuleArray"
                              hide-details="auto"
                              v-model="offer.DeliveryLocations"
                              item-text="Value"
                              item-value="Key"
                              :items="allLocations"
                              outlined
                              multiple
                              label="Delivery Location"
                              ><template slot="append-outer">
                                <v-icon v-if="!showDeliveryNotes" @click="showDeliveryNotes = true" title="Add more delivery location details"
                                  >mdi-text-box-plus-outline</v-icon
                                ><v-icon v-else @click="onHideDeliveryNotes" title="Remove delivery location details"
                                  >mdi-text-box-remove-outline</v-icon
                                ></template
                              ></v-autocomplete
                            >
                          </v-col>
                          <v-col cols="12" v-if="showDeliveryNotes">
                            <v-textarea rows="3" dense hide-details="auto" v-model="offer.DeliveryLocationNote" outlined label="DeliveryNotes"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              :rules="requiredRuleArray"
                              hide-details="auto"
                              multiple
                              v-model="offer.RedeliveryLocations"
                              item-text="Value"
                              item-value="Key"
                              :items="allLocations"
                              outlined
                              label="Redelivery Location"
                              ><template slot="append-outer">
                                <v-icon v-if="!showRedeliveryNotes" @click="showRedeliveryNotes = true" title="Add more redelivery location details"
                                  >mdi-text-box-plus-outline</v-icon
                                ><v-icon v-else @click="onHideRedeliveryNotes" title="Remove redelivery location details"
                                  >mdi-text-box-remove-outline</v-icon
                                ></template
                              ></v-autocomplete
                            >
                          </v-col>
                          <v-col cols="12" v-if="showRedeliveryNotes">
                            <v-textarea
                              rows="3"
                              dense
                              hide-details="auto"
                              v-model="offer.RedeliveryLocationNote"
                              outlined
                              label="Redelivery Notes"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <v-text-field dense :rules="requiredRule" hide-details="auto" v-model="offer.Contract" outlined label="Contract"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea dense rows="3" hide-details="auto" v-model="offer.ContractNotes" outlined label="Contract Notes"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea dense rows="3" hide-details="auto" v-model="offer.SubjectNotes" outlined label="Subject Notes"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              dense
                              rows="3"
                              hide-details="auto"
                              v-model="offer.SupportingDocuments"
                              outlined
                              label="Supporting Documents"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <v-combobox
                              :items="allDuties"
                              dense
                              :rules="requiredRule"
                              hide-details="auto"
                              v-model="offer.Duty"
                              outlined
                              label="Duties"
                            ></v-combobox>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea dense rows="3" hide-details="auto" v-model="offer.DutyNotes" outlined label="Duty Notes"></v-textarea>
                          </v-col>

                          <v-col cols="12">
                            <v-textarea dense rows="3" hide-details="auto" v-model="offer.OfferNotes" outlined label="General Notes"></v-textarea>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-form ref="periodform">
                    <v-row>
                      <v-col cols="12">
                        <period-list type="offer" :periods="offer.OfferPeriods"></period-list>
                      </v-col>
                      <v-col cols="6">
                        <v-row>
                          <v-col cols="6">
                            <v-select
                              dense
                              hide-details="auto"
                              v-model="offer.MobilisationFeeCurrency"
                              :items="allCurrencies"
                              item-text="Value"
                              item-value="Key"
                              outlined
                              label="Mob Currency"
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              dense
                              hide-details="auto"
                              v-model.number="offer.MobilisationFee"
                              type="number"
                              outlined
                              label="Mob Fee"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field dense hide-details="auto" v-model.number="offer.MobilisationNote" outlined label="Mobilisation Note"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-select
                              dense
                              hide-details="auto"
                              v-model="offer.DemobilisationFeeCurrency"
                              :items="allCurrencies"
                              item-text="Value"
                              item-value="Key"
                              outlined
                              label="Demob Currency"
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              dense
                              hide-details="auto"
                              v-model.number="offer.DemobilisationFee"
                              type="number"
                              outlined
                              label="Demob Fee"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              dense
                              hide-details="auto"
                              v-model.number="offer.DemobilisationNote"
                              outlined
                              label="Demobilisation Note"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-textarea dense rows="3" hide-details="auto" v-model="offer.PeriodNotes" outlined label="Period Notes"></v-textarea>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-textarea dense rows="3" hide-details="auto" v-model="offer.AvailabilityNotes" outlined label="Availability Notes"></v-textarea>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-textarea dense rows="3" hide-details="auto" v-model="offer.Victualling" outlined label="Victualling Details"></v-textarea>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-textarea dense rows="3" hide-details="auto" v-model="offer.OfferValidity" outlined label="Validity of Offer"></v-textarea>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-textarea dense rows="3" hide-details="auto" v-model="offer.IncludedInCost" outlined label="Included in Rate"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <v-form ref="vesselform">
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              :rules="requiredRule"
                              hide-details="auto"
                              v-model="offer.VesselId"
                              item-text="Value"
                              item-value="Key"
                              :items="allVessels"
                              outlined
                              label="Vessel"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              disabled
                              hide-details="auto"
                              v-model="ownerId"
                              item-text="Value"
                              item-value="Key"
                              :items="allOwners"
                              outlined
                              label="Owner"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              disabled
                              hide-details="auto"
                              v-model="commercialManagerId"
                              item-text="Value"
                              item-value="Key"
                              :items="allOwners"
                              outlined
                              label="Commercial Manager"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              dense
                              hide-details="auto"
                              v-model="offer.VesselSafetyStatistic"
                              item-text="Value"
                              item-value="Key"
                              :items="allSafetyStatistics"
                              outlined
                              label="Vessel Safety Statistic"
                            ></v-select>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              dense
                              hide-details="auto"
                              v-model="offer.CompanySafetyStatistic"
                              item-text="Value"
                              item-value="Key"
                              :items="allSafetyStatistics"
                              outlined
                              label="Company Safety Statistic"
                            ></v-select>
                          </v-col>

                          <v-col cols="12">
                            <v-checkbox dense hide-details v-model="offer.KentorLink" label="Kenter Link"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-col cols="12">
                          <v-menu v-model="cmidMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                outlined
                                :hide-details="isCmidValid"
                                v-model="cmidFormatted"
                                label="CMID"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :class="[isCmidValid ? '' : 'data-warning']"
                                :persistent-hint="!isCmidValid"
                                :hint="isCmidValid ? '' : offer.Cmid ? 'CMID date is more than 12 months ago' : 'No CMID date provided'"
                                @blur="offer.Cmid = parseDate(cmidFormatted)"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="offer.Cmid" @input="cmidMenu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12">
                          <v-menu v-model="ovidMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                outlined
                                :hide-details="isOvidValid"
                                v-model="ovidFormatted"
                                label="OVID"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :class="[isOvidValid ? '' : 'data-warning']"
                                @blur="offer.Ovid = parseDate(ovidFormatted)"
                                :persistent-hint="!isOvidValid"
                                :hint="isOvidValid ? '' : offer.Ovid ? 'OVID date is more than 12 months ago' : 'No OVID date provided'"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="offer.Ovid" @input="ovidMenu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12">
                          <v-menu
                            v-model="dpTrialMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                outlined
                                hide-details
                                v-model="dpTrialFormatted"
                                label="Annual DP Trial"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @blur="offer.AnnualDPTrial = parseDate(dpTrialFormatted)"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="offer.AnnualDPTrial" @input="dpTrialMenu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12">
                          <v-menu v-model="fmeaMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                outlined
                                hide-details
                                v-model="fmeaFormatted"
                                label="FMEA"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @blur="offer.FMEA = parseDate(fmeaFormatted)"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="offer.FMEA" @input="fmeaMenu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12">
                          <v-checkbox dense hide-details v-model="offer.IsWaterCertificate" label="Valid Water Certificate"></v-checkbox>
                        </v-col>
                        <v-col cols="12" v-if="offer.IsWaterCertificate">
                          <v-menu v-model="waterMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="waterCertificateFormatted"
                                label="Water Certificate Date"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @blur="offer.WaterCertificateDate = parseDate(waterCertificateFormatted)"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="offer.WaterCertificateDate" @input="waterMenu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12">
                          <v-checkbox dense hide-details v-model="offer.IsFuelCertificate" label="Valid Fuel Certificate"></v-checkbox>
                        </v-col>
                        <v-col cols="12" v-if="offer.IsFuelCertificate">
                          <v-menu v-model="fuelMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                dense
                                hide-details
                                v-model="fuelCertificateFormatted"
                                label="Fuel Certificate Date"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @blur="offer.FuelCertificateDate = parseDate(fuelCertificateFormatted)"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="offer.FuelCertificateDate" @input="fuelMenu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <v-menu
                              v-model="crewChangeMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  dense
                                  outlined
                                  :hide-details="isCrewChangeValid"
                                  v-model="crewChangeFormatted"
                                  label="Next Crew Change Date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  :class="[isCrewChangeValid ? '' : 'data-warning']"
                                  :persistent-hint="!isCrewChangeValid"
                                  :hint="isCrewChangeValid ? '' : offer.CrewChange ? 'Crew Change Date has already passed' : 'No crew change date provided'"
                                  @blur="offer.CrewChange = parseDate(crewChangeFormatted)"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="offer.CrewChange" @input="crewChangeMenu = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              rows="3"
                              dense
                              hide-details="auto"
                              v-model="offer.CrewChangeFlexibility"
                              outlined
                              label="Flexibility on Crew Change"
                            ></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea rows="3" dense hide-details="auto" v-model="offer.CrewChangeNotes" outlined label="Crew Change Notes"></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-checkbox dense hide-details v-model="offer.IsCrewChangeConfirmed" label="Crew Change Confirmed"></v-checkbox>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              hide-details="auto"
                              multiple
                              v-model="offer.PilotExemptionCrew1"
                              item-text="Value"
                              item-value="Key"
                              :items="allLocations"
                              outlined
                              label="Pilot Exemption (Crew 1)"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              dense
                              hide-details="auto"
                              multiple
                              v-model="offer.PilotExemptionCrew2"
                              item-text="Value"
                              item-value="Key"
                              :items="allLocations"
                              outlined
                              label="Pilot Exemption (Crew 2)"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12">
                            <v-checkbox dense hide-details v-model="offer.IsCrewListAttached" label="Crew List Included"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content step="4">
                  <v-form ref="costform">
                    <cost-breakdown-table
                      ref="costbreakdown"
                      v-on:updated="onCostBreakDownUpdated"
                      :offerCostBreakdown="selectedCostBreakdown"
                    ></cost-breakdown-table>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content step="5">
                  <v-form ref="cargoform">
                    COMING SOON! I PROMISE!
                  </v-form>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="closeModal()">
              Cancel
            </v-btn>
            <v-btn class="warning" @click="onSaveClick('PEN')" v-if="offer.OfferId && offer.OfferStatus == 'APP'">
              Unapprove
            </v-btn>
            <!--             <v-spacer v-if="offer.Status == 'PEN'"></v-spacer>
            <v-btn v-if="offer.Status == 'PEN'" class="success--text" @click="sendToOwnerForApproval()">
              {{ `Send to Owner for Approval` }}
            </v-btn> -->
            <v-spacer></v-spacer>
            <v-btn class="success--text" @click="onSaveClick()">
              {{ isEdit ? `Save` : `Add` }}
            </v-btn>
            <v-btn v-if="offer.OfferStatus != 'APP' || offer.OfferStatus != 'APPO'" class="success--text" @click="onSaveClick('APP')">
              {{ isEdit ? `Approve` : `Add and Approve` }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="beforeSaveDialog" max-width="500px">
      <v-card>
        <v-card-text class="subtitle-1 pt-3 text-center">{{ beforeSaveText }}</v-card-text>
        <v-card-actions>
          <v-btn @click="onCancelBeforeSave">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="createOrUpdate">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  background-image: linear-gradient(white 80%, transparent);
  z-index: 1;
}
.v-stepper__header {
  box-shadow: none;
}
</style>
